export const USER_SERVICE = "/user/v1";

export const USER_ACTIVE_SCHOOL_YEAR = `${USER_SERVICE}/schoolyear/active/detail.json`;
